import React from "react";
import alert from "../../../assets/alert.png";
import { observer } from "mobx-react-lite";
import { useCreateLeagueMatchStore } from "../../../store/StoreContext";
import { TCText } from "../../../components/tcText/TCText";
import { convertToHours } from "../../../utils/utils";
import { Colors } from "../../../utils/colors";

type props = {};

export const MinimumPlayingTime: React.FC<props> = observer(() => {
  const createLeagueMatchStore = useCreateLeagueMatchStore();
  return !createLeagueMatchStore.isMinimumPlayingTimeCovered ? (
    <div
      style={{
        backgroundColor: "rgba(212, 175, 96, 0.2)",
        height: 36,
        width: "100%",
        maxWidth: "800px",
        margin: "10px auto 20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 12,
        gap: 10,
      }}>
      <img src={alert} alt="" style={{ height: 16, width: 16 }} />
      <TCText
        style={{ fontWeight: 500, fontSize: 10, color: Colors.yellow }}
        value={`Minimum playing time is ${convertToHours(
          createLeagueMatchStore.minimumPlayingTime
        )}`}
      />
    </div>
  ) : null;
});
